import OptionalChip from "@/components/Common/forms/OptionalChip";
import SkeletonLoader from "@/components/onboarding/SkeletonLoader";
import clsxm from "@/lib/clsxm";
import type {FC} from "react";
import TextareaAutosize, {type TextareaAutosizeProps} from "react-textarea-autosize";

const AutosizeTextarea: FC<
  TextareaAutosizeProps & {
    className?: string;
    htmlFor?: string;
    isLoading?: boolean;
    optional?: boolean;
    title?: string;
    titleClassName?: string;
  }
> = ({className, htmlFor, isLoading, optional, title, titleClassName, ...props}) => {
  return (
    <div className="flex w-full flex-col gap-1">
      {title && (
        <label
          className={clsxm("text-neutral-grey-dark flex items-center gap-2 text-sm font-medium", titleClassName)}
          htmlFor={htmlFor}>
          {optional && <OptionalChip />}
          {title}
        </label>
      )}
      {isLoading ? (
        <SkeletonLoader
          className={clsxm(
            "disabled:bg-neutral-white-dark disabled:text-neutral-grey-dark border-primary-light-dark text-neutral-black placeholder:text-neutral-grey-light focus:border-primary-medium-solid flex min-h-15 w-full resize-none rounded-md border bg-white p-4 pr-0 outline-hidden transition-all duration-150 placeholder:text-sm disabled:cursor-not-allowed md:placeholder:text-base",
            className,
          )}
        />
      ) : (
        <TextareaAutosize
          {...props}
          className={clsxm(
            "disabled:bg-neutral-white-dark disabled:text-neutral-grey-dark border-primary-light-dark text-neutral-black placeholder:text-neutral-grey-light focus:border-primary-medium-solid flex min-h-15 w-full resize-none rounded-md border bg-white p-4 pr-0 outline-hidden transition-all duration-150 placeholder:text-sm disabled:cursor-not-allowed md:placeholder:text-base",
            className,
          )}
        />
      )}
    </div>
  );
};

export default AutosizeTextarea;
